const throttleMap = new Map();

/**
 * @param {string} key - Unique key for the action
 * @param {Function} callback - Function to execute
 * @param {number} delay - Delay in ms (default 3000)
 */
export const throttleClick = (key, callback, delay = 3000) => {
  const now = Date.now();
  const lastCall = throttleMap.get(key) || 0;

  if (now - lastCall < delay) {
    return;
  }

  throttleMap.set(key, now);
  callback();
};

// Optional: Clear a key if needed
export const clearThrottle = (key) => {
  throttleMap.delete(key);
};